import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IconsComponent } from '@sml/icons';

@Component({
  selector: 'sml-accordion',
  templateUrl: './accordion.component.html',
  standalone: true,
  imports: [
    CommonModule,
    IconsComponent
  ],
})
export class AccordionComponent {
  @Input() heading = '';
  @Input() subHeading = '';
  @Input() isOpen = false;
  @Input() containDomElement = false;
  @Input() itemCardOriginalDescription=false;
  @Input () accordionClass="";
  toggleAccordion(): void {
    this.isOpen = !this.isOpen;
  }
}
